import { Component, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { GeographyMasterService } from '../geography_master.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
    selector: 'area-master',
    templateUrl: './area_master.component.html'
})
export class areaMaster {

    collectionDetails = [];
    searchDataPafing = [];

    indexStart = 0;
    indexEnd = 10;
    pageSize = 5;
    pageNo = 1;
    totalPage = [1];

    searchInput = '';
    IsRecordUpdated = false;

    areaName = '';
    code = '';
    ButtonValue = 'Save';
    viewMode = false;
    CreatedBy = '';
    IsDeleting = false;
    DeletedIndex = '';
    createdDate = '';
    country: any;
    cityId = '';
    city = [];
    areaId = '';

    cityArray = [];


    constructor(private router: Router,
        public toastr: ToastsManager, vcr: ViewContainerRef,
        private PaymentService: GeographyMasterService,
        private fb: FormBuilder) {

        this.toastr.setRootViewContainerRef(vcr);
        this.PaymentService.GetCityList('')
            .subscribe(departmentListData => {
                this.cityArray = departmentListData;
            });


        this.PaymentService.GetAreaList('')
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }
                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }


    pagingAgent(data) {
        this.pageNo = data;
        this.indexStart = (this.pageNo - 1) * this.pageSize + 1;
        this.indexEnd = (this.pageNo) * this.pageSize;
    }

    changeItemsPerPage(data) {
        if (this.collectionDetails.length > 0) {
            this.totalPage = [1]
            let j = 1;
            for (var i = 0; i < this.collectionDetails.length; i++) {
                i = i + this.pageSize;
                j = j + 1;
                this.totalPage.push(j);
            }
        }
        else {
            this.totalPage = [];
        }
        this.pageSize = data;
        this.indexStart = 0;
        this.indexEnd = this.pageSize;
    }

    searchInputFunction() {
        this.PaymentService.GetAreaList(this.searchInput)
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                console.log("data", departmentListData);
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }

                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }

    UpdateRecordsPopulate(obj) {
        this.viewMode = false;
        this.areaName = obj["description"];
        this.code = obj["code"];
        this.cityId = obj["cityId"];
        this.createdDate = obj['createdDate'];
        this.ButtonValue = 'Update';
        this.city = obj['city'];
        this.areaId = obj['id'];
    }

    ViewRecordsPopulate(obj) {
        this.viewMode = true;
        this.areaName = obj["description"];
        this.code = obj["code"];
        this.IsRecordUpdated = true;
        this.ButtonValue = 'Save';
        this.cityId = obj["cityId"];
    }

    reset() {
        this.viewMode = false;
        this.areaName = '';
        this.code = '';
        this.ButtonValue = 'Save';
        this.cityId = '';
        this.city = [];
        this.areaId ='';
    }

    memberFormSubmit() {
        if (this.areaId != '') {
            let data = {
                "city": this.city,
                "cityId": this.cityId,
                "code": this.code,
                "createdBy": null,
                "createdDate": this.createdDate,
                "description": this.areaName,
                "id": this.areaId,
                "isDeleted": false,
                "lastModifiedBy": '',
                "lastModifiedDate": null,
                "pinCodeId": []
            }
            this.PaymentService.EditArea(data)
                .subscribe(departmentListData => {
                    if (departmentListData == "Success") {
                        this.toastr.success("Record updated succesfuly.");
                        this.LoadGrid();
                    }
                    else {
                        this.toastr.error("Area Name and Code already exists.");
                    }
                });
        }
        else {
            let data = {
                "cityId": this.cityId,
                "code": this.code,
                "description": this.areaName,
                "loggedInUserId":''
            }
            this.PaymentService.CreateArea(data)
                .subscribe(departmentListData => {
                    if (departmentListData == "Success") {
                        this.toastr.success("Record Added succesfuly.");
                        this.LoadGrid();
                    }
                    else {
                        this.toastr.error("City Name and Code already exists.");
                    }
                });
        }
    }

    codegen() {
    }

    deleteProdutConfirm(id, i) {
        this.cityId = id;
        this.IsDeleting = true;
        this.DeletedIndex = i;
    }
    delete() {
        let data = {
            "id": this.cityId,
            "trackingState": this.DeletedIndex
        }
        // this.PaymentService.DeleteProductGroup(data)
        //     .subscribe(departmentListData => {

        //     });
    }
    deleteCancel() {
        this.IsDeleting = false;
        this.cityId = '';
        this.DeletedIndex = '';
    }

    LoadGrid() {
        this.PaymentService.GetAreaList(this.searchInput)
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                console.log("data", departmentListData);
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }
                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/system_setting/geography_master/area_master/area_master.component.ts